import React, { useState } from 'react';
import { Button, Stack } from 'react-bootstrap';
import { FormViewer, SchemaTypes } from '@ai4/form-viewer';

export interface Props {
	formSchema: SchemaTypes.Schema;
	formOptions?: any;
	record?: any;
	extraData?: any;
	onSetHelpers?: (args: any) => void;
	onInit: (args: any) => Promise<any>;
	onChange: (args: any) => Promise<any>;
	onAddExtraData: (args: any) => Promise<any>;
	onDirty?: (flag: boolean) => void;
	onSubmit: (args: any) => Promise<any>;
	onCancel: (forceExit?: boolean) => void;
	onSuccess?: (args: any) => void;
	onError?: (args: any) => void;
	onSelectFiles?: (args: any) => void;
	onRemoveFile?: (args: any) => void;
	onDownloadFile?: (args: any) => string;
	onFieldValidate?: (args: any) => any;
	onValidate?: (args: any) => any;
	submitResponse: any;
}

export function RecordForm(props: Props) {
	const {
		formSchema,
		formOptions,
		record,
		extraData = {},
		onSetHelpers,
		onInit,
		onChange,
		onAddExtraData,
		onDirty,
		onValidate,
		onSubmit,
		onCancel,
		onSuccess,
		onError,
		submitResponse,
		...rest
	} = props;
	const { loading } = submitResponse;

	return (
		<div>
			<FormViewer
				{...rest}
				schema={formSchema}
				initialValues={record || null}
				options={formOptions}
				onCancelWhenModified={() => {
					return `Continuando perderai tutte le tue modifiche. Vuoi continuare?`;
				}}
				onInit={(form: any) => {
					if (onSetHelpers) onSetHelpers(form);
					if (onInit) onInit(form);
				}}
				onChange={(form: any) => {
					if (onChange)
						onChange({
							...form,
							setExtraData: onAddExtraData,
						});
					if (onDirty) onDirty(form.dirty);
				}}
				onValidate={(args: any) => {
					const { values } = args;
					if (onValidate) {
						return onValidate({
							values: {
								...values,
								...extraData,
							},
						});
					}
					return null;
				}}
				onSubmit={(args: any) => {
					const { values, form } = args;
					const newArgs = { ...args, values: { ...values, ...extraData } };
					onSubmit(newArgs)
						.then((res) => {
							const values = res.data;
							// form.resetForm({ values });
							if (onSuccess) onSuccess(values);
						})
						.catch((err) => {
							if (onError) onError(err);
						})
						.finally(() => {
							form.setSubmitting(false);
						});
				}}
				slots={{
					ButtonBar: (props: any) => {
						const { form } = props;
						return (
							<Stack direction='horizontal' gap={3}>
								<Button variant='secondary' type='button' onClick={() => onCancel()}>
									Annulla
								</Button>
								<Button
									variant='primary'
									type='submit'
									disabled={!form.isValid || form.isSubmitting}
									className='ms-auto'
								>
									Salva
								</Button>
							</Stack>
						);
					},
				}}
			/>
		</div>
	);
}

export default RecordForm;
